/* global jQuery */
import plugin from "@core/plugins/lib";
import debug from "debug";

const ELEMENT_SELECTOR = "[data-compare-summary]";
const PLUGIN_NAME = "compareSummary";

const log = debug(PLUGIN_NAME);

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

class CompareSummary {
	constructor(element, options) {
		log("element", element);
		log("options", options);

		this.options = options;
		this.element = element;

		// Elements
		// - frequency select
		// - excess radios
		// - rate display

		this.frequencyInput = this.element.querySelector(
			this.options.frequencyInputSelector
		);

		this.excessInput = this.element.querySelector(
			this.options.excessInputSelector
		);
		this.excessInputsArray = [
			...this.element.querySelectorAll(this.options.excessInputSelector)
		];

		// Specifically has excess options
		this.hasMultipleProducts = !!this.options.excessInputSelector;

		this.rateDisplay = this.element.querySelector(
			this.options.rateDisplaySelector
		);

		this.futureRateDisplay = this.element.querySelector(
			this.options.futureRateDisplaySelector
		);

		// Rate may not be displayed
		// Only run associated update method if it is
		this.updateRateDisplay = this.rateDisplay
			? this.updateRateDisplayMethod
			: ()=>{};

		this.updateFutureRateDisplay = this.futureRateDisplay
			? this.updateFutureRateDisplayMethod
			: ()=>{};

		this.frequencies = this.frequencyInput
			? [...this.frequencyInput.options].map(option => {
					return option.value;
			  })
			: [];

		this.syncElements = {
			"data-compare-summary--sync-frequency": this.frequencyInput
			//, 'data-compare-summary--sync-excess': this.excessInput.form.elements[this.excessInput.name]
		};

		// Extract rates data from inputs for this product
		this.rates = this.hasMultipleProducts
			? this.getRatesFromInputs()
			: this.getRatesFromData();

		this.futureRates = this.hasMultipleProducts
		? this.getFutureRatesFromInputs()
		: this.getFutureRatesFromData();

		this.attributeObserver = new MutationObserver(
			this.onAttributeChange.bind(this)
		);

		this.watch();

		log("ready", this, this.element);
	}

	watch() {
		log("watching");

		this.element.addEventListener("change", this.onChange.bind(this));
		this.attributeObserver.observe(this.element, { attributes: true });
	}

	getRatesFromInputs() {
		return this.excessInputsArray.reduce((object, input) => {
			return Object.assign(
				{
					[input.id]: getJSONValue(input.dataset["rates"])
				},
				object
			);
		}, {});
	}

	getFutureRatesFromInputs() {
		return this.excessInputsArray.reduce((object, input) => {
			return Object.assign(
				{
					[input.id]: getJSONValue(input.dataset["futureRates"])
				},
				object
			);
		}, {});
	}

	getRatesFromData() {
		return {
			'rates': getJSONValue(this.options.syncRates)
		};
	}

	getFutureRatesFromData() {
		return {
			'rates': getJSONValue(this.options.syncFutureRates)
		};
	}

	onChange() {
		// update form element data attr
		for (const attr in this.syncElements) {
			const value = this.syncElements[attr].value;
			this.element.setAttribute(attr, value);
		}

		// sync rates data attr - ref for cover selector component
		const chosenRates = this.rates[this.getProductId()];
		this.element.setAttribute(
			"data-compare-summary--sync-rates",
			JSON.stringify(chosenRates)
		);

		const chosenFutureRates = this.futureRates[this.getProductId()];
		this.element.setAttribute(
			"data-compare-summary--sync-future-rates",
			JSON.stringify(chosenFutureRates)
		);

		this.updateRateDisplay();
		this.updateFutureRateDisplay();

		// update other instances
		$(this.element).trigger("coverchange");
	}

	onAttributeChange(mutationList, observer) {
		mutationList
			.filter(
				function(mutation) {
					return (
						mutation.type === "attributes" &&
						this.syncElements[mutation.attributeName]
					);
				}.bind(this)
			)
			.forEach(this.applyAttributeChanges.bind(this));
	}

	// Update value of corresponding form elements
	applyAttributeChanges(mutation) {
		const attribute = mutation.attributeName;
		const newValue = this.element.getAttribute(attribute);
		const input = this.syncElements[attribute];
		input.value = newValue;
		this.updateRateDisplay();
		this.updateFutureRateDisplay();
	}

	updateRateDisplayMethod() {
		const frequency = this.frequencyInput.value;
		const productId = this.getProductId();
		this.rateDisplay.textContent = this.getRate(
			productId,
			frequency
		).toFixed(2);
	}

	updateFutureRateDisplayMethod() {
		const frequency = this.frequencyInput.value;
		const productId = this.getProductId();
		this.futureRateDisplay.textContent = this.getFutureRate(
			productId,
			frequency
		).toFixed(2);
	}

	getRate(productId, frequency) {
		const frequencyIndex = this.frequencies.findIndex(periodName => {
			return frequency === periodName;
		});

		return this.rates[productId][frequencyIndex];
	}

	getFutureRate(productId, frequency) {
		const frequencyIndex = this.frequencies.findIndex(periodName => {
			return frequency === periodName;
		});

		return this.futureRates[productId][frequencyIndex];
	}

	getProductId() {
		if (!this.hasMultipleProducts) {
			return 'rates';
		}
		const checkedExcessInput = this.excessInputsArray.find(input => {
			return input.checked;
		});

		return checkedExcessInput.id;
	}
}

CompareSummary.DEFAULTS = {};

plugin(PLUGIN_NAME, CompareSummary);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./project/client/src/core/modules/cover-selector/components/cover-selector/compare-summary.js